import React from 'react';

// TermsOfService Component
const Terms = () => {
  return (
    <div className="terms-container">
      <style>{`
        /* Basic Reset & Font */
     

        /* Container Styling */
        .terms-container {

          margin: 20px auto;
          padding: 100px 7% 0px;
          line-height:;
        }

        /* Headings */
        .terms-container h1 {
          font-size: 36px;
          color: #212529;
          margin-bottom: 25px;
          text-align: center;
          padding-bottom: 15px;
        }

        .terms-container h2 {
          font-size: 22px;
          color: #212529;
          margin-top: 30px;
          margin-bottom: 8px;
        }

        .terms-container h3 {
          font-size: 1.4em;
          color: #343a40;
          margin-top: 20px;
          margin-bottom: 10px;
        }

        /* Paragraphs */
        .terms-container p {
          margin-bottom: 1em;
        }

        /* Lists */
        .terms-container ul {
          list-style: disc;
          margin-left: 25px;
          margin-bottom: 1em;
        }

        .terms-container ol {
          list-style: decimal;
          margin-left: 25px;
          margin-bottom: 1em;
        }

        .terms-container li {
          margin-bottom: 0.5em;
          font-size:16px;
          font-weight:400;
        }

        /* Links */
        .terms-container a {
          text-decoration: none;
          color: #f3b200;
        }

        .terms-container a:hover {
          text-decoration: underline;
        }

        /* Responsive Adjustments */
        @media (max-width: 767px) {
          .terms-container {
            margin: 15px;
            padding: 20px;
          }

          .terms-container h1 {
            font-size: 24px;
            margin-bottom: 20px;
          }

          .terms-container h2 {
            font-size: 20px;
            margin-top: 25px;
          }

          .terms-container h3 {
            font-size: 18px;
            margin-top: 18px;
          }

        }
     
        @media (max-width: 480px) {
          .terms-container {
            margin: 10px;
            padding: 15px;
            border-radius: 8px;
          }

          .terms-container ul,
          .terms-container ol {
            margin-left: 20px;
          }
        }
      `}</style>

      <h1>Terms and Conditions</h1>
      <p><em>Last updated: June 22, 2025</em></p>

      <p>Welcome to Haronics! These Terms of Service ("Terms") govern your use of the Haronics website (the "Site") and any related services provided by Haronics ("we," "us," or "our"). By accessing or using the Site, you agree to be bound by these Terms. If you disagree with any part of the terms, then you may not access the Site.</p>

      <h2>1. Acceptance of Terms</h2>
      <p>By accessing and using this website, you accept and agree to be bound by these Terms. You must be at least 18 years old to use this Site. If you are under 18, you may use the Site only with the involvement of a parent or guardian.</p>

      <h2>2. Acceptable Use</h2>
      <p>You agree not to use the Site for any unlawful purpose or any purpose prohibited by these Terms. You agree not to use the Site in any way that could damage, disable, overburden, or impair the Site or interfere with any other party's use and enjoyment of the Site.</p>
      <ul>
        <li>You will not upload or transmit any computer viruses, worms, or any other malicious code.</li>
        <li>You will not collect or harvest any personally identifiable information from the Site.</li>
        <li>You will not attempt to gain unauthorized access to any portion or feature of the Site, or any other systems or networks connected to the Site.</li>
      </ul>

      <h2>3. Account Registration</h2>
      <p>If certain features of the Site require you to register an account, you agree to provide accurate and complete information and to keep this information up to date. You are responsible for maintaining the confidentiality of your account password and for all activities that occur under your account.</p>

      <h2>4. Intellectual Property</h2>
      <p>The Site and its original content, features, and functionality are and will remain the exclusive property of Haronics and its licensors. The Site is protected by copyright, trademark, and other laws of both the Specify Region</p>
      <p>You may not reproduce, distribute, modify, create derivative works of, publicly display, publicly perform, republish, download, store, or transmit any of the material on our Site, except as generally permitted by standard web browsers for personal, non-commercial use.</p>

      <h2>5. User Content</h2>
      <p>You are solely responsible for the content that you submit, post, or display on or through the Site ("User Content"). You represent and warrant that you own or have the necessary licenses, rights, consents, and permissions to publish User Content.</p>
      <p>We are not responsible for the User Content and expressly disclaim all liability arising from it. We reserve the right, but are not obligated, to remove or modify any User Content for any reason.</p>

      <h2>6. Links to Other Websites</h2>
      <p>Our Site may contain links to third-party websites or services that are not owned or controlled by Haronics. Haronics has no control over, and assumes no responsibility for, the content, privacy policies, or practices of any third-party websites or services. You further acknowledge and agree that Haronics shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with the use of or reliance on any such content, goods, or services available on or through any such websites or services.</p>

      <h2>7. Disclaimers and Limitation of Liability</h2>
      <p>The Site is provided on an "AS IS" and "AS AVAILABLE" basis. Haronics makes no warranties, express or implied, regarding the operation or availability of the Site or the information, content, materials, or products included on this Site.</p>
      <p>To the fullest extent permissible by applicable law, Haronics disclaims all warranties, express or implied, including, but not limited to, implied warranties of merchantability and fitness for a particular purpose.</p>
      <p>In no event shall Haronics, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from (i) your access to or use of or inability to access or use the Site; (ii) any conduct or content of any third party on the Site; (iii) any content obtained from the Site; and (iv) unauthorized access, use, or alteration of your transmissions or content, whether based on warranty, contract, tort (including negligence), or any other legal theory, whether or not we have been informed of the possibility of such damage, and even if a remedy set forth herein is found to have failed of its essential purpose.</p>

      <h2>8. Indemnification</h2>
      <p>You agree to defend, indemnify, and hold harmless Haronics and its licensee and licensors, and their employees, contractors, agents, officers, and directors, from and against any and all claims, damages, obligations, losses, liabilities, costs or debt, and expenses (including but not limited to attorney's fees), resulting from or arising out of a) your use and access of the Site, by you or any person using your account and password; b) a breach of these Terms, or c) content posted on the Site.</p>

      <h2>9. Severability</h2>
      <p>If any provision of these Terms is held to be invalid or unenforceable, the remaining provisions of these Terms will remain in full force and effect.</p>

      <h2>10. Waiver</h2>
      <p>No waiver of any term of these Terms shall be deemed a further or continuing waiver of such term or any other term, and Haronics's failure to assert any right or provision under these Terms shall not constitute a waiver of such right or provision.</p>

      <h2>11. Governing Law and Jurisdiction</h2>
      <p>These Terms shall be governed and construed in accordance with the laws of Specify Jurisdiction, Karnataka, India, without regard to its conflict of law provisions.</p>
      <p>Any dispute arising out of or in connection with these Terms, including any question regarding its existence, validity, or termination, shall be referred to and finally resolved by the courts in  Bengaluru, Karnataka, India.</p>

      <h2>12. Termination</h2>
      <p>We may terminate or suspend your access immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.</p>
      <p>Upon termination, your right to use the Site will immediately cease.</p>

      <h2>13. Entire Agreement</h2>
      <p>These Terms constitute the entire agreement between Haronics and you regarding our Site, and supersede and replace any prior agreements we might have between us regarding the Site.</p>

      <h2>14. Contact Us</h2>
      <p>If you have any questions about these Terms, please contact us at: <a href="haronicsindia@gmail.com" className='terms'>haronicsindia@gmail.com</a></p>
    </div>
  );
};

export default Terms;
